import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import * as api from '../../util/api';

// ================ Async thunks ================ //

export const createVeriffSessionThunk = createAsyncThunk(
  'VerificationPage/createVeriffSession',
  (params, { rejectWithValue }) => {
    return api.createVeriffSession(params)
      .then(res => {
        if (res.url) {
          return res.url;
        } else {
          throw new Error('Failed to get verification URL');
        }
      })
      .catch(e => {
        return rejectWithValue(storableError(e));
      });
  }
);

// Wrapper for presentational component
export const createVeriffSession = params => dispatch => {
  return dispatch(createVeriffSessionThunk(params)).unwrap();
};

// ================ Slice ================ //

const verificationSlice = createSlice({
  name: 'VerificationPage',
  initialState: {
    createVeriffSessionInProgress: false,
    createVeriffSessionError: null,
    veriffSessionUrl: null,
  },
  reducers: {
    clearVerificationPage: state => {
      state.createVeriffSessionInProgress = false;
      state.createVeriffSessionError = null;
      state.veriffSessionUrl = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(createVeriffSessionThunk.pending, state => {
        state.createVeriffSessionInProgress = true;
        state.createVeriffSessionError = null;
      })
      .addCase(createVeriffSessionThunk.fulfilled, (state, action) => {
        state.createVeriffSessionInProgress = false;
        state.veriffSessionUrl = action.payload;
      })
      .addCase(createVeriffSessionThunk.rejected, (state, action) => {
        console.error(action.payload);
        state.createVeriffSessionInProgress = false;
        state.createVeriffSessionError = action.payload;
      });
  },
});

export const { clearVerificationPage } = verificationSlice.actions;

export default verificationSlice.reducer;
